export default __webpack_public_path__ + "static/media/stake-more-uni.9be3257f.svg";